export const fileNameToId = ({ name }: { name: string }): string =>
  name.replace(/[.\s]/, "-");
